import toast from "react-hot-toast";

const { clientAPI } = require("../client");

// Xăng xe: NV nhận xăng xe phải chấm ra mới đủ công, không nhận thì không cần chấm ra
const showError = (error) => {
  const errorMessages = error?.response?.data?.errors?.map(
    (err) => err.message,
  ) || [
    error?.response?.data?.message ||
      error?.response?.statusText ||
      error?.message ||
      "An unexpected error occurred.",
  ];

  errorMessages.forEach((message) => {
    toast.error(`${message}`);
  });
};

export const fuelAllowanceCall = {
  // HCNS đổi trực tiếp loại xăng xe của NV
  updateEmployee: async (id, data) => {
    try {
      return await clientAPI("put", `/fuelAllowance/employees/${id}`, data);
    } catch (error) {
      console.error("Update fuel allowance error:", error);
      showError(error);
      throw error;
    }
  },

  handleRequest: async (id, data) => {
    try {
      return await clientAPI(
        "put",
        `/fuelAllowance/requests/${id}/handle`,
        data,
      );
    } catch (error) {
      console.error("Handle fuel request error:", error);
      showError(error);
      throw error;
    }
  },
};
